import { deriveMarketplacesFromSessions } from "./deriveMarketplacesFromSessions";
import { deriveProductTypesFromSessions } from "./deriveProductTypesFromSessions";

export function finishedSessionFilters(
  marketplace: string,
  productType: string,
) {
  const session = [{ marketplace, productType }];
  const [mp] = deriveMarketplacesFromSessions(session);
  const [pt] = deriveProductTypesFromSessions(session);
  return {
    marketplaces: [mp],
    productTypes: [pt],
    selectedMarketplace: mp.name,
    selectedProductType: pt.name,
  };
}
